module.exports = __webpack_public_path__ + "static/media/icon-circle-light-full.b6526b3b.svg";